import { render, staticRenderFns } from "./plan-detail-container.vue?vue&type=template&id=1964d131&scoped=true"
import script from "./plan-detail-container.vue?vue&type=script&lang=js"
export * from "./plan-detail-container.vue?vue&type=script&lang=js"
import style0 from "./plan-detail-container.vue?vue&type=style&index=0&id=1964d131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964d131",
  null
  
)

export default component.exports